import { Axis } from '../axis.class';

export const rotateCfn = (axis: Axis, rotation: Axis): Axis => {
	if (axis.x !== null) axis.x = (axis.x + rotation.x) % 360;
	if (axis.y !== null) axis.y = (axis.y + rotation.y) % 360;
	if (axis.z !== null) axis.z = (axis.z + rotation.z) % 360;

	return axis;
};
